import type { FC } from 'react';

import type { PaymentsSummary, PaymentTab } from '@/types/payment.types';

import { PAYMENT_TABS } from '../constants';

interface PaymentsToolbarProps {
  tab: PaymentTab;
  search: string;
  summary: PaymentsSummary | undefined;
  onChangeTab: (tab: PaymentTab) => void;
  onChangeSearch: (search: string) => void;
}

const badgeFor = (tab: PaymentTab, summary: PaymentsSummary | undefined): number => {
  if (!summary) return 0;
  if (tab === 'submitted') return summary.awaitingVerificationCount;
  if (tab === 'to_settle') return summary.pendingSettlementCount;
  return 0;
};

const PaymentsToolbar: FC<PaymentsToolbarProps> = ({
  tab,
  search,
  summary,
  onChangeTab,
  onChangeSearch,
}) => (
  <div className="flex flex-col gap-3 border-b border-[var(--color-divider)] p-4 md:flex-row md:items-center md:justify-between">
    <div className="flex flex-wrap gap-2">
      {PAYMENT_TABS.map(({ key, label }) => {
        const badge = badgeFor(key, summary);
        const active = key === tab;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChangeTab(key)}
            className={`rounded-full px-3 py-1.5 text-[12px] font-semibold transition-colors ${
              active
                ? 'bg-brand-500 text-white'
                : 'bg-[var(--color-surface-muted)] text-[var(--color-ink-muted)] hover:text-[var(--color-ink)]'
            }`}
          >
            {label}
            {badge > 0 ? ` (${badge})` : ''}
          </button>
        );
      })}
    </div>
    <input
      value={search}
      onChange={(e) => onChangeSearch(e.target.value)}
      placeholder="Search payment / booking code"
      className="w-full rounded-lg border border-[var(--color-divider)] bg-white px-3 py-2 text-[13px] text-[var(--color-ink)] outline-none focus:border-brand-300 md:w-64"
    />
  </div>
);

export default PaymentsToolbar;
